import DBTable from "../../../../../component/global/DBTable/DBTable";
import {get} from "../../../../../controlers/global/ConfigRequest";
import {useEffect, useMemo, useState} from "react";
import {GET_PACKAGE_LOGS} from "../../../../../helperData/ApiAddress";
import {Spinner} from "react-bootstrap";
import moment from "moment-jalaali";
import {useTranslation} from "react-i18next";

function PackagesRecords() {
  const [loading, setLoading] = useState(true)
  const [rows, setRows] = useState([])
  const {t} = useTranslation()

  const headers = useMemo(() => {
    return [
      {
        id: 'row',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.Row'),
        gridTemplateColumns: '55px'
      },
      {
        id: 'type',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.Type'),
        gridTemplateColumns: '88px'
      },
      {
        id: 'price',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.Price'),
        gridTemplateColumns: '100px',
        numberWithComma: true,
      },
      {
        id: 'startDate',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.StartDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
        headerStyle: {},
      },
      {
        id: 'endDate',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.EndDate'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center', whiteSpace: 'break-spaces'},
      },
      {
        id: 'volume',
        title: t('Organizational.Profile.Packages.Report.Packages.Table.Volume'),
        gridTemplateColumns: '100px',
        rowStyle: {textAlign: 'center'},
      },
    ]
  }, [t])

  useEffect(() => {
    get(GET_PACKAGE_LOGS)
      .then(res => {
        console.log('res', res)
        if (res?.results?.length) {
          const tmp = res.results.map((item, index) => {
            const startDate = moment(item.created_at).format('jYYYY/jMM/jDD')
            const startTime = moment(item.created_at).format('HH:MM')
            let endDate = ''
            let endTime = ''
            if (item.duration_as_days) {
              const date = moment(item.created_at).add(item.duration_as_days, 'd')
              endDate = date.format('jYYYY/jMM/jDD')
              endTime = date.format('HH:MM')
            }
            return {
              row: index + 1,
              price: item.price,
              type: item.package.name,
              startDate: `${startDate} \n ${startTime}`,
              endDate: `${endDate} \n ${endTime}`,
              volume: `${item.storage_volume} مگ`,
            }
          })
          setRows(tmp)
        }
      })
      .finally(() => setLoading(false))
  }, [])

  if (loading) return <Spinner animation="border" style={{marginTop: 20}}/>;
  return (
    <div>
      <DBTable width={610} headers={headers} rows={rows}/>
    </div>
  );
}

export default PackagesRecords;
